import { __assign, __rest } from "tslib";
import React from 'react';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import CommentBoxContainer from './CommentBox.container';
import CommentBox from './CommentBox';
import CommentBox2 from '../CommentBox2/presets/CommentBox';
var FeatureBranchAdapter = function (_a) {
    var initiallyExpanded = _a.initiallyExpanded, rest = __rest(_a, ["initiallyExpanded"]);
    return React.createElement(CommentBox2, __assign({ forceLoadOnMount: initiallyExpanded }, rest));
};
export default withFeatureBranch({
    commentbox_refactor: FeatureBranchAdapter,
})(CommentBoxContainer(CommentBox));
//# sourceMappingURL=index.js.map